import { render, staticRenderFns } from "./authentication-side-panel.vue?vue&type=template&id=18223940&"
import script from "./authentication-side-panel.vue?vue&type=script&lang=js&"
export * from "./authentication-side-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports